// extracted by mini-css-extract-plugin
export default {"inputError":"CustomInpurField_inputError__w-WKx"};